<pbc-sorter [config]="UmkreissucheSorterConfig" [sorter]="umkreissuche.sorter$ | async" (sorterChange)="umkreissuche.sorter$.next($event)"></pbc-sorter>
